// Maps between the IDP admin access-model wire shapes (src/api/access.types.ts)
// and the domain types the service account Access tab speaks. Sibling to the
// users feature's own accessTransformer.ts — kept separate (rather than
// reused) because it owns a different resource path (/v1/admin/serviceaccounts
// vs /v1/admin/role-assignments + /v1/admin/users/{id}/access), even though
// the wire shapes it maps happen to be identical.
import type { AccessPreviewResponse, AllowedScopesResponse, RoleAssignmentResponse } from '@/api/access.types'
import type { AccessPreview, RoleAssignment } from '@/features/users'
import type { AllowedScope } from '../types'

export function toRoleAssignment(response: RoleAssignmentResponse): RoleAssignment {
  return { product: response.product, roleId: response.roleId }
}

export function toAccessPreview(response: AccessPreviewResponse): AccessPreview {
  return {
    scopes: response.scopes,
    roles: response.roles,
    permissions: response.permissions,
    resourceScope: {
      tenant: response.resourceScope.tenant,
      accounts: response.resourceScope.accounts,
    },
  }
}

export function toAllowedScopes(response: AllowedScopesResponse): AllowedScope[] {
  return response.scopes.map((scope) => ({ id: scope.id, value: scope.value }))
}
